import Vue from 'vue'

export const SET_LOAN = 'SET_LOAN'

export default {
  [SET_LOAN](state, loan) {
    Vue.set(state, 'loan', loan)
  },
}
